export enum enumPaymentBillType {
  CUSTOM,
  LCL,
  MARINE_INSURANCE,
}
